import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Sheet from "components/core/Sheet";
import Card from "components/core/Card";
import Stack from "components/core/Stack";
import Input from "components/core/Input";
import Button from "components/core/Button";
import Link from "components/core/Link";
import Typography from "components/core/Typography";
import authActions from "actions/authActions";
import appActions from "actions/appActions";
import { Notice } from "domain";

const ForgotPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            await dispatch(authActions.reset(email));
            await dispatch(appActions.addNotice(new Notice({
                title: 'Reset Link Sent',
                details: 'Please check your email, and use the provided link to reset your password.',
                type: Notice.TYPE_SUCCESS
            })));
            setEmail('');
            navigate('/');
        } catch (err) {
            // Handle error
        }
    };

    return (
        <Sheet 
            sx={{
                margin: 0,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                height: '100vh',
                backgroundImage: 'url(/api/placeholder/1920/1080)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'primary.50'
            }}
        >
            <Card
                sx={{
                    width: '100%',
                    maxWidth: 400,
                    p: 8,
                    background: 'rgba(255, 255, 255, 0.5)',
                    backdropFilter: 'blur(10px)',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Stack spacing={8} alignItems="center" sx={{ width: '100%' }}>
                    <img
                        src={'./img/short_logo.png'}
                        alt={''}
                        width={160} 
                    />
                    
                    <Stack spacing={4} alignItems="center" sx={{ width: '100%' }}>
                        <Typography level="h4">Forgot Password</Typography>
                        
                        <Typography level="body-md" sx={{ textAlign: 'center' }}>
                            Enter your email address and we will send you a link to reset your password.
                        </Typography>

                        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Stack spacing={4} alignItems="center">
                                <Input
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(value) => setEmail(value)}
                                    sx={{ width: '100%' }}
                                />
                                
                                <Button 
                                    type="submit" 
                                    disabled={!email}
                                    sx={{ width: '100%' }}
                                >
                                    Send Reset Link
                                </Button>
                                
                                <Link 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate('/');
                                    }}
                                    component="button"
                                    variant="plain"
                                    size="sm"
                                >
                                    Back to Login
                                </Link>
                            </Stack>
                        </form>
                    </Stack>
                </Stack>
            </Card>
        </Sheet>
    );
};

export default ForgotPassword;